/// <reference path="../../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";

import * as Rest from "../../Generated/RestClient";
import { BotChannels } from "./BotChannels";
import { Resources } from "../../Resources/Intercom.Resources.DevPortal";

export interface EmbedCodePanelProps extends React.Props<EmbedCodePanel> {
    botId: string;
    contacts: Rest.ContactCard[];
    webChatClick?: () => void;
}

export interface EmbedCodePanelState {
    currentChannelContact?: Rest.ContactCard;
}

export class EmbedCodePanel extends React.Component<EmbedCodePanelProps, EmbedCodePanelState> {
    constructor(props) {
        super(props);

        this.handleFirstFocusTrapFocus = this.handleFirstFocusTrapFocus.bind(this);
        this.handleLastFocusTrapFocus = this.handleLastFocusTrapFocus.bind(this);
        this.handleEmbedCodeFocus = this.handleEmbedCodeFocus.bind(this);

        this.saveCloseButton = this.saveCloseButton.bind(this);
        this.saveEmbedCode = this.saveEmbedCode.bind(this);

        this.state = {
            currentChannelContact: (this.props.contacts.length > 0) ? this.props.contacts[0] : null
        };
    }

    componentDidMount() {
        this.focusEmbedCode();
    }

    private _closeButton: React.ReactInstance;
    private _embedCode: React.ReactInstance;

    private onChannelClick(contact: Rest.ContactCard): void {
        this.setState({ currentChannelContact: contact });
    }

    private getFooter(): JSX.Element {
        if (this.state.currentChannelContact.ChannelName === 'Facebook')
            return (
                <div className="embed-footer">
                    <span>
                        {Resources.embedPanelFacebookFooter} <a href="https://developers.facebook.com/docs/messenger-platform/plugin-reference">{Resources.embedPanelLearnMore}</a>
                    </span>
                </div>
            );
        else
            return null;
    }

    private externalLink(): JSX.Element {
        const path = this.props.webChatClick ? "javascript:void(0)" : BotChannels.getConfigUrl(this.props.botId, this.state.currentChannelContact.ChannelId);
        return (
            <div>
                <div className="embed-code-name">{Resources.embedPanelChannelMovedHeader.replace('%1', this.state.currentChannelContact.ChannelName)}</div>
                <a href={path} target="_self" onClick={this.props.webChatClick || null} ref={this.saveEmbedCode}>
                    {Resources.embedPanelChannelMovedInstructions.replace('%1', this.state.currentChannelContact.ChannelName)} <span className="icon-font">{'\uE0E3'}</span>
                </a>
            </div>
        );
    }

    private embedInfo(): JSX.Element {
        let beforeCodeValue: JSX.Element[] = null;
        let beforeCodeNote: JSX.Element = null;

        if (this.state.currentChannelContact.Secret) {
            beforeCodeValue = [
                (
                    <div className="embed-code-name">Secret</div>
                ), (
                    <div className="embed-code-text">
                        <div className="embed-code">{this.state.currentChannelContact.Secret}</div>
                    </div>
                )
            ];
        }

        if (this.state.currentChannelContact.Note) {
            beforeCodeNote = (
                <div className="embed-code-note">{this.state.currentChannelContact.Note}</div>
            );
        }

        return (
            <div>
                {beforeCodeValue}
                {beforeCodeNote}
                <div className="embed-code-name"><label htmlFor="bot-channel-embed-code-label">{Resources.embedPanelEmbedcodeForChannelLabel.replace('%1', this.state.currentChannelContact.ChannelName)}</label></div>
                <div className="embed-code-text">
                    <div className="embed-channel-icon-panel"><img className="embed-channel-icon" alt={this.state.currentChannelContact.ChannelName} src={this.state.currentChannelContact.ChannelIconUrl} /></div>
                    <textarea
                        className="embed-code"
                        id="bot-channel-embed-code-label"
                        ref={this.saveEmbedCode}
                        readOnly
                        onFocus={this.handleEmbedCodeFocus}
                        rows={3}
                        value={this.state.currentChannelContact.HtmlLink}></textarea>
                    <div className="clean" />
                </div>
            </div>
        );
    }

    private focusCloseButton() {
        const closeButtonElement = ReactDOM.findDOMNode(this._closeButton) as HTMLElement;

        closeButtonElement && closeButtonElement.focus();
    }

    private focusEmbedCode() {
        const embedCodeElement = ReactDOM.findDOMNode(this._embedCode) as HTMLElement;

        embedCodeElement && embedCodeElement.focus();
    }

    private handleEmbedCodeFocus() {
        const embedCodeElement = ReactDOM.findDOMNode(this._embedCode) as HTMLTextAreaElement;

        embedCodeElement && embedCodeElement.select();
    }

    private handleFirstFocusTrapFocus() {
        this.focusEmbedCode();
    }

    private handleLastFocusTrapFocus() {
        this.focusCloseButton();
    }

    private saveCloseButton(closeButton) {
        this._closeButton = closeButton;
    }

    private saveEmbedCode(embedCode) {
        this._embedCode = embedCode;
    }

    public render(): JSX.Element {
        const iconList = this.props.contacts.map(contact =>
            <button
                key={contact.ChannelId + "-button"}
                className="image-button-container"
                type="button"
                title={contact.ChannelName}
                onClick={() => this.onChannelClick(contact)}>
                <img className="embed-channel-icon"
                    alt={contact.ChannelName}
                    src={contact.ChannelIconUrl}
                />
            </button>
        );
        return (
            <div className="embed-code-panel">
                <div
                    className="focus-trap"
                    aria-hidden="true"
                    onFocus={this.handleFirstFocusTrapFocus}
                    tabIndex={0}
                />
                <button className="dialog-close-button" aria-label="Close" ref={this.saveCloseButton} type="button"></button>
                <div id="dialog-title" className="embed-title">{Resources.embedPanelTitle}</div>
                <div className="embed-desc">{Resources.embedPanelDescription}</div>
                <div className="embed-icon-list">{iconList}</div>
                {this.state.currentChannelContact.ChannelId === 'webchat' ? this.externalLink() : this.embedInfo()}
                {this.getFooter()}
                <div
                    className="focus-trap"
                    aria-hidden="true"
                    onFocus={this.handleLastFocusTrapFocus}
                    tabIndex={0}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/EmbedCodePanel.tsx